import React from 'react';
import { ArrowForward, Lock, VpnKey, EnhancedEncryption } from '@mui/icons-material';

const EncryptionDiagram = () => {
    const steps = [
        {
            icon: Lock,
            title: '1. Authentification',
            description: 'Votre application s\'authentifie avec OAuth2',
            color: 'blue'
        },
        {
            icon: EnhancedEncryption,
            title: '2. Chiffrement TLS',
            description: 'Connexion sécurisée avec TLS 1.3',
            color: 'green'
        },
        {
            icon: VpnKey,
            title: '3. Signature',
            description: 'Les données sensibles sont signees',
            color: 'purple'
        },
        {
            icon: Lock,
            title: '4. Stockage Sécurisé',
            description: 'Les signatures sont stocker dans nos serveurs pour certification ulterieur',
            color: 'amber'
        }
    ];

    return (
        <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">
                        Chiffrement de Bout en Bout
                    </h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Chaque étape de la transaction est protégée par des mécanismes de sécurité multiples.
                    </p>
                </div>

                <div className="relative">
                    {/* Ligne de connexion */}
                    <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-gray-200 transform -translate-y-1/2 hidden md:block"></div>

                    <div className="grid md:grid-cols-4 gap-8 relative z-10">
                        {steps.map((step, index) => (
                            <div key={index} className="text-center">
                                <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${
                                    step.color === 'blue' ? 'bg-blue-100' :
                                        step.color === 'green' ? 'bg-green-100' :
                                            step.color === 'purple' ? 'bg-purple-100' : 'bg-amber-100'
                                }`}>
                                    <step.icon className={`text-2xl ${
                                        step.color === 'blue' ? 'text-blue-600' :
                                            step.color === 'green' ? 'text-green-600' :
                                                step.color === 'purple' ? 'text-purple-600' : 'text-amber-600'
                                    }`} />
                                </div>

                                <h3 className="font-semibold text-gray-900 mb-2">{step.title}</h3>
                                <p className="text-sm text-gray-600">{step.description}</p>

                                {index < steps.length - 1 && (
                                    <div className="hidden md:block absolute top-1/2 left-1/4 transform -translate-y-1/2">
                                        <ArrowForward className="text-gray-400" />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Code Example */}
                <div className="mt-12 bg-gray-900 rounded-2xl p-6">
                    <h4 className="text-white font-semibold mb-4">Exemple de Signature de donnee en Java</h4>
                    <pre className="text-green-400 text-sm overflow-x-auto">
            <code>
{`// Signature des données sensibles
private String signPayload(String payload, String secret) throws Exception {
        Mac sha256_HMAC = Mac.getInstance("HmacSHA256");
        SecretKeySpec secretKey = new SecretKeySpec(secret.getBytes(), "HmacSHA256");
        sha256_HMAC.init(secretKey);
        return Base64.getEncoder().encodeToString(sha256_HMAC.doFinal(payload.getBytes()));
    }
    
    `}
            </code>
          </pre>
                </div>
            </div>
        </section>
    );
};

export default EncryptionDiagram;